// Ranking comparator for attraction lists.
//
// Rating alone can't rank parks: ~99% sit in 4.0-5.0 and a tiny neighbourhood
// park with a handful of reviews often shows a perfect 5.0. `notability`
// (0 = unknown, higher = more notable) is set offline from verified signals
// (national/state parks, botanic gardens, Wikipedia language-edition count).
//
// IMPORTANT: notability is only filled for parks, so it must NOT be a primary
// sort key — that would put every park ahead of every museum/temple/shop. It is
// folded into a single score that only moves PARK rows; everything else keeps its
// plain rating order:
//   - known park (notability > 0): small bonus
//   - generic city park with no notability signal: pushed down by UNKNOWN_PARK_PENALTY
const CITY_PARK = '城市公園/植物綠地';
const UNKNOWN_PARK_PENALTY = 1.0;

export const rankScore = (a) =>
  (Number(a.rating) || 0) +
  (a.notability || 0) * 0.05 -
  (a.specify_cat === CITY_PARK && !a.notability ? UNKNOWN_PARK_PENALTY : 0);

export const byRankScore = (a, b) => rankScore(b) - rankScore(a);
